<template>
  <div class="detail" v-loading.fullscreen.lock="materialSaving || planRemarkSaving">
    <!-- 头部 -->
    <div class="header">
      <detailHeader />
      <orderHeader v-if="show" :detail="detail" @pre-service-saved="orderDetails" />
    </div>

    <!-- 订单 -->
    <div class="order" v-if="isOrder">
      <!-- 显示隐藏 -->
      <div class="top-btn">
        <!-- 整番显示 -->
        <el-button type="primary" @click="roundDisplay(!isShowList)">
          {{ !isShowList ? $t('message.roundDisplay') : $t('message.roundHide') }}
        </el-button>
        <div class="item" v-for="(item, index) in orderType" :key="index" :class="{ select: typeIndex == index }"
          @click="filterList(item.value, index)">
          {{ item.value }}({{ item.num }})
        </div>
        <el-button type="primary" class="columnSettingsButton" @click="columnSettingsVisible = true">
          {{ $t('message.customColumns') }}
        </el-button>
        <el-button v-if="materialRows.length" class="materialBatchToggle" @click="toggleAllMaterials">
          {{ allMaterialsExpanded ? $t('message.materialCollapseAll') : $t('message.materialExpandAll') }}
        </el-button>
      </div>
      <div class="orderDetail">
        <!-- 订单列表 -->
        <div class="tableList" v-if="show">
          <!-- 列表头部 -->
          <ol>
            <li class="fixed-left no-column">
              NO / {{ $t('message.choose') }}
            </li>
            <!-- 店铺信息 -->
            <li v-if="isColumnVisible('shopInformation')" class="flex1-5 shop" style="cursor: pointer;"
              @dblclick="reCompletion">
              {{ $t("message.storeInformation") }}
            </li>
            <!-- 照片 -->
            <li v-if="isColumnVisible('picture')">
              {{ $t("message.pic") }}
            </li>
            <!-- 客户下单详情 -->
            <li v-if="isColumnVisible('customerOrderDetails')" class="important">
              {{ $t("message.customerOrderDetails") }}
            </li>
            <!-- 业务编辑属性 -->
            <li v-if="isColumnVisible('businessEditAttributes')" class="flex2">
              {{ $t("message.businessEditAttributes") }}
            </li>
            <!-- 报价-->
            <li v-if="isColumnVisible('businessOffer')" class="flex1-5">
              {{ $t("message.businessOffer") }}
            </li>
            <!-- 客户付款后数量 -->
            <li v-if="isColumnVisible('customerAfterPaymentQuantity')" class="flex1-5">
              {{ $t("message.customerAfterPaymentQuantity") }}
            </li>
            <!-- 最终采购成本 -->
            <li class="flex1-5" v-if="userRole && isColumnVisible('finalPurchaseCost')">
              {{ $t("message.finalPurchaseCost") }}
            </li>
            <!-- 客户付款后价格 -->
            <li v-if="isColumnVisible('customerAfterPaymentPrice')" class="flex1-5">
              {{ $t("message.customerAfterPaymentPrice") }}
            </li>
            <!-- 附加服务 -->
            <li v-if="isColumnVisible('additionalServices')" class="flex2">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 标签编号 -->
            <li v-if="isColumnVisible('tagNumber')" class="tag-number">
              {{ $t("message.tagNumber") }}
            </li>
            <!-- 交易号/物流号 -->
            <li v-if="isColumnVisible('transactionLogisticsNumber')" class="flex3 important">
              {{ $t("message.transactionNumberLogisticsNumber") }}
            </li>
            <!-- 装箱情况 -->
            <li v-if="isColumnVisible('packingCase')" class="flex2">
              {{ $t("message.packingCase") }}
            </li>
            <!-- 客户备注 -->
            <li v-if="isColumnVisible('customerProductRemarks')" class="flex2 customerRemarkHeader">
              {{ $t("message.customerProductRemarks") }}
            </li>
            <!-- 业务商 -->
            <li v-if="isColumnVisible('businessCommodityRemarks')" class="flex2 remarkGroupHeader">
              {{ $t("message.businessCommodityRemarks") }}
            </li>
            <!-- 采购商品备注 -->
            <li v-if="isColumnVisible('purchaseCommodityRemarks')" class="flex2 remarkGroupHeader">
              {{ $t("message.remarksForPurchasedCommodities") }}
            </li>
            <!-- 配货备注 -->
            <li v-if="isColumnVisible('deliveryProductRemarks')" class="flex2 remarkGroupHeader">
              {{ $t("message.deliveryProductRemarks") }}
            </li>
            <!-- 业务跟单备注 -->
            <li v-if="isColumnVisible('businessFollowUpRemarks')" class="flex2 remarkGroupHeader">
              {{ $t("message.businessFollowUpRemarks") }}
            </li>
            <!-- 业务跟单备注 （内部）-->
            <li v-if="isColumnVisible('businessFollowUpInternalRemarks')" class="flex2 remarkGroupHeader">
              {{ $t("message.businessFollowUpRemarks") }}（内部）
            </li>
            <!-- 采购跟单备注 -->
            <li v-if="isColumnVisible('purchaseDocumentaryRemarks')" class="flex2 remarkGroupHeader">
              {{ $t("message.purchaseDocumentaryRemarks") }}
            </li>

            <!-- 配送单号 -->
            <li v-if="isColumnVisible('porderNumber')" class="flex2 important orderReferenceHeader">
              {{ $t("message.porderNumber") }}
            </li>
            <!-- 国际物流单号 -->
            <li v-if="isColumnVisible('internationalLogisticsOrderNumber')"
              class="flex2 important orderReferenceHeader">
              {{ $t("message.internationalLogisticsOrderNumber") }}
            </li>
            <!-- 替换链接 -->
            <li v-if="isColumnVisible('replaceTheLink')">
              {{ $t("message.replaceTheLink") }}
            </li>
            <!-- 状态 -->
            <li v-if="isColumnVisible('status')" class="fixed-right">
              {{ $t("message.status") }}
            </li>
            <!-- 跟单备注 -->
            <li v-if="isColumnVisible('documentaryRemarks')">
              {{ $t("message.documentaryRemarks") }}
            </li>
          </ol>
          <!-- list -->
          <div class="list" v-for="(item, index) in order_detail" :key="item.id">
            <!-- 主订单 -->
            <ul
              :class="{ editItem: item.is_client_modify == 1, addItem: item.client_modify_field.indexOf('all') != -1 }">
              <li class="NO fixed-left no-column" @click.stop="item.show = !item.show">
                <!-- 第一行固定为复选框、番号和采购明细展开图标。 -->
                <div class="noTopRow">
                  <div class="noSelection" @click.stop>
                    <el-popover placement="right" title="合计数量" width="200" trigger="focus">
                      <statistics :checkedList="selectedList" :orderPaymen="true" />
                      <el-checkbox v-model="item.checked" @change="orderChecked" slot="reference"></el-checkbox>
                    </el-popover>
                  </div>
                  <b>{{ item.sorting }}
                    <i class="el-icon-caret-bottom" v-if="item.show"></i>
                    <i v-else class="el-icon-caret-right"></i></b>
                </div>

                <!-- 条件标识使用中间弹性区域，按实际内容自然撑开。 -->
                <div class="noStatusArea">
                  <div class="noBadgeRow">
                    <!-- 售前问题 -->
                    <el-popover placement="top-end" width="350" trigger="hover">
                      <div v-for="(problem_goods) in item.problem_goods">
                        <p>问题提出时间：{{ problem_goods.created_at }}</p>
                        <p>问题类别：{{ problem_goods.type_name }}</p>
                        <p>具体问题描述：{{ problem_goods.description }}</p>
                      </div>
                      <router-link
                        :to="'/pre-saleProblem?order_sn=' + detail.order_sn + '&status=' + item.problem_goods[item.problem_goods.length - 1].status"
                        target="_blank" v-if="item.problem_goods != false" slot="reference" class="wen">问
                      </router-link>
                    </el-popover>
                    <!-- 售中问题 -->
                    <el-popover placement="top-end" width="350" trigger="hover">
                      <div v-for="(in_sale) in item.in_sale">
                        <p>问题提出时间：{{ in_sale.created_at }}</p>
                        <p>问题类别：{{ in_sale.type_name }}</p>
                        <p>具体问题描述：{{ in_sale.description }}</p>
                      </div>
                      <router-link
                        :to="'/inSaleList?order_sn=' + detail.order_sn + '&status=' + item.in_sale[item.in_sale.length - 1].status"
                        target="_blank" v-if="item.in_sale != false" slot="reference" class="wen inSale">问
                      </router-link>
                    </el-popover>
                    <div v-if="isMaterial(item)" class="materialMarkTip" @click.stop>
                      <MaterialMarkTip :material-id="item.material_id || (item.material && item.material.id)"
                        :user-id="detail.user_id" :detail="item.material || {}" />
                    </div>
                  </div>
                  <!-- 是否加入商品管理 -->
                  <div class="claim" v-if="item.client_product_mark">
                    <router-link
                      :to="{ name: 'productManagementV2', query: { tab: 'all', user_id: detail.user_id, client_sku_code: item.client_sku_code } }"
                      target="_blank">
                      <i :class="item.client_product_mark == 1 ? 'el-icon-shopping-bag-1' : 'el-icon-s-claim'"></i>
                    </router-link>
                  </div>
                  <div class="isZhu" v-if="item.isZhu" @click="$refs.kitAssembly.getDataList(item.group)">
                    组套-主
                  </div>
                  <div class="isZhu isTong" v-if="item.set_detail_id != '' && item.set_detail_id != -1"
                    @click="$refs.kitAssembly.getDataList(item.group)">
                    组套-{{ getSorting(item.set_detail_id) }}番-同捆
                  </div>
                  <spotCheckDetails v-if="item.spotDetail" :spotDetail="item.spotDetail" />
                  <div class="contraband">
                    <el-popover placement="right" width="200" trigger="hover"
                      v-if="item.forbid_goods != false && item.forbid_goods != null">
                      <div> {{ item.forbid_goods.type_name }}</div>
                      <img src="@/assets/img/contraband1.png" alt="" slot="reference"
                        v-if="item.forbid_goods.status == 3" style="width: 30px;">
                      <img src="@/assets/img/contraband.png" alt="" slot="reference" v-else style="width: 30px;">
                    </el-popover>
                  </div>
                </div>
                <!-- 已付款订单无辅料时也保留要求查看入口。 -->
                <el-button class="materialToggle" type="text" size="mini"
                  @click.stop="toggleMaterial(item)">
                  {{ item.materialExpanded ? $t("message.collapse") : $t("message.expand") }}
                  <i :class="item.materialExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </el-button>
              </li>
              <!-- 店铺信息 -->
              <li v-if="isColumnVisible('shopInformation')" class="flex1-5 shop">
                <div class="template">
                  <div class="shopName" :title="item.shop_name">{{ item.shop_name }}</div>
                  <p style="color: #15ad3c;margin: 5px 0; ">{{ item.from_platform }} ({{ (item.service_rate *
                    100).toFixed(1) }}%)</p>
                  <div class="shopName goodsId" :title="item.goods_id" @click="item.goods_id && copy(item.goods_id)">
                    {{ item.goods_id || '-' }}
                  </div>
                  <!-- 供应商订单标签 -->
                  <p v-if="item.is_supplier_goods == 1">
                    <el-tag size="mini" type="primary" class="primary" effect="dark">供应商订单</el-tag>
                  </p>
                  <!-- 供应商报价 -->
                  <p v-if="item.is_supplier_goods == 1"> <el-tag size="mini"
                      :type="item.is_supplier_quoted == 1 ? 'success' : 'primary'" effect="dark">{{
                        item.is_supplier_quoted == 1 ? '供应商已报价' : '待供应商报价' }}</el-tag></p>
                </div>
              </li>
              <!-- 照片 -->
              <li v-if="isColumnVisible('picture')" class="pic">
                <div>
                  

                  <!-- tort_detect 不为空，且双路风险任一明确为高风险时显示入口 -->
                  <el-tag class="tort-detect-tag" size="mini" effect="dark"
                    :type="getTortRiskType(item.tort_detect)"
                    v-if="isShowTortRisk(item.tort_detect)" @click.stop="openTortDetect(item)">
                    侵权风险
                  </el-tag>
                  <div class="editpic" v-if="isAuth(583)">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :on-success="updateOrderImage" :before-upload="beforeAvatarUpload">
                      <i class="el-icon-edit-outline" @click="setPic(index, item.id)"></i>
                    </el-upload>
                  </div>
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; " />
                    <a :href="item.link" slot="reference" target="_blank">
                      <el-image :src="item.pic" style="width: 53px; height: 53px; border-radius: 4px">
                        <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                        </div>
                      </el-image>
                    </a>
                  </el-popover>
                  <input v-if="isAuth(579)" v-model="item.for_sn" class="nativeListInput" type="text"
                    placeholder="管理番号" @blur="batchUpdateOrderDetailForSn(item)">
                  <p v-else>{{ item.for_sn }}</p>
                </div>
              </li>
              <!-- 客户下单详情 -->
              <li v-if="isColumnVisible('customerOrderDetails')">
                <el-popover placement="right" width="840" trigger="hover">
                  <userOrderDetail :item="item" :index="index" />
                  <el-button type="success" size="mini" slot="reference">
                    {{ $t("message.particulars") }}
                  </el-button>
                </el-popover>
              </li>
              <!-- 业务编辑属性 -->
              <li v-if="isColumnVisible('businessEditAttributes')" class="flex2">
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                  <i class="el-icon-edit-outline" @click="attributeEdit(item, index, 'Y')" v-if="isAuth(492)">
                  </i>
                  <!-- 待补充重量尺寸 -->
                  <p v-if="item.record_dimension_tasks != false">
                    <el-tag size="mini" type="primary" effect="dark" class="primary"
                      v-if="item.record_dimension_tasks[0].status == 0">待补充重量尺寸</el-tag>
                  </p>
                  <!-- 待补充重量尺寸 -->
                  <p v-if="item.record_duration_tasks != false">
                    <el-tag size="mini" type="primary" effect="dark" `
                      v-if="item.record_duration_tasks[0].status == 0">待业务录入时效</el-tag>
                  </p>
                </div>
              </li>
              <!-- 报价-->
              <li v-if="isColumnVisible('businessOffer')" class="flex1-5">
                <div class="template">
                  <p
                    :style="{ background: item.offer_num_bak == 0 ? 'red' : '', color: item.offer_num_bak == 0 ? '#fff' : '' }">
                    {{ $t("message.inStock") }}:{{ item.offer_num_bak }}</p>
                  <p>{{ $t("message.price") }}:{{ item.offer_price_bak }}</p>
                  <p>{{ $t("message.freight") }}:{{ item.offer_freight_bak }}</p>
                </div>
              </li>
              <!-- 客户付款后数量 -->
              <li v-if="isColumnVisible('customerAfterPaymentQuantity')" class="flex1-5">
                <div class="template attribute">
                  <!-- 可入库 -->
                  <p class="row">{{ $t("message.canBePutIntoStorage") }}:{{ item.possible_num_total }}</p>
                  <!-- 已到货 -->
                  <p>{{ $t("message.itHasArrived") }}:{{ item.storage_num_total }}</p>
                  <!-- 已出货 -->
                  <p>{{ $t("message.shipped") }}:{{ item.delivery_total }}</p>
                </div>
              </li>
              <!-- 最终采购成本 -->
              <li class="flex1-5" v-if="userRole && isColumnVisible('finalPurchaseCost')">
                ————
                <!-- {{ item.confirm_dicker_price }} -->
              </li>
              <!-- 客户付款后价格 -->
              <li v-if="isColumnVisible('customerAfterPaymentPrice')" class="flex1-5">
                <div class="template attribute">
                  <!-- 单价 -->
                  <p class="row">{{ $t("message.unitPrice") }}:{{ item.confirm_price }}</p>
                  <!-- 运费 -->
                  <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
                </div>
              </li>
              <!-- 附加服务 -->
              <li v-if="isColumnVisible('additionalServices')" class="flex2 additionalServicesCell">
                <div class="attribute services">
                  <el-tag v-if="Number(item.is_fba_pre) === 1" type="success" size="mini" class="fba-pre-tag">
                    标签前置处理
                  </el-tag>
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                        </p>
                      </div>
                    </div>
                    <div class="serviceOptionList">
                      <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 标签编号 -->
              <li v-if="isColumnVisible('tagNumber')" class="tag-number">
                <div class="attribute tag-content">
                  <div v-for="(tag, tagIndex) in item.order_detail_tag" :key="tagIndex" class="tag-card">
                    <div class="tag-actions">
                      <el-button type="primary" size="mini" @click.stop="editTag(item, tag)">{{ $t("message.compile") }}</el-button>
                      <el-button type="danger" size="mini" @click.stop="deleteTag(item, tag)" class="dark">{{ $t("message.delete") }}</el-button>
                      <el-button :type="tag.is_print ? 'info' : 'success'" size="mini" @click.stop="printTag(item, tag)" class="tag-print">{{ tag.is_print ? $t("message.printed") : $t("message.print") }}</el-button>
                    </div>
                    <div class="tag-record">
                      <div class="tag-field"><span class="tag-label">类别</span><span class="tag-value">{{ tag.type }}</span></div>
                      <div class="tag-field"><span class="tag-label">标签号</span><span class="tag-value">{{ tag.no }}</span></div>
                      <div class="tag-field"><span class="tag-label">商品码</span><span class="tag-value">{{ tag.goods_no }}</span></div>
                      <div class="tag-field">
                        <span class="tag-label">标签数量</span>
                        <span class="tag-value tag-count-value">
                          <span>{{ tag.num }}</span>
                          <!-- 纯文本标与配送单一致，放在标签数量行并通过 hide 模式打印。 -->
                          <el-button type="primary" size="mini" @click.stop="printTag(item, tag, 'hide')">
                            {{ $t("message.plainTextLabel") }}
                          </el-button>
                        </span>
                      </div>
                      <div class="tag-field"><span class="tag-label">编码类型</span><span class="tag-value">{{ tag.code_type }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本1</span><span class="tag-value">{{ tag.text_line_one }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本2</span><span class="tag-value">{{ tag.text_line_two }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本3</span><span class="tag-value">{{ tag.text_line_three }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本4</span><span class="tag-value">{{ tag.text_line_four }}</span></div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- 交易号/物流号 -->
              <li v-if="isColumnVisible('transactionLogisticsNumber')" class="flex3">————</li>
              <!-- 装箱情况 -->
              <li v-if="isColumnVisible('packingCase')" class="flex2">
                {{ item.hasNotCompleteBox ? '装箱中' : '————' }}
              </li>
              <!-- 客户备注 -->
              <li v-if="isColumnVisible('customerProductRemarks')" class="flex2 remarkCell customerRemarkCell">
                <!-- <p class="text"> :title="item.client_remark" {{ item.client_remark }}</p> -->
                <textarea v-model="item.client_remark" class="nativeListTextarea" disabled></textarea>
              </li>
              <!-- 业务翻译 -->
              <li v-if="isColumnVisible('businessCommodityRemarks')" class="flex2 remarkCell">
                <textarea v-if="role == 1 && isAuth(180)" v-model="item.y_remark" class="nativeListTextarea"
                  @blur="updateGoodsRemark(item, item.y_remark, 1)"></textarea>
                <span v-else>{{ item.y_remark }}</span>
              </li>
              <!-- 采购备注 -->
              <li v-if="isColumnVisible('purchaseCommodityRemarks')" class="flex2 remarkCell">
                <div class="text" :title="item.g_remark"> {{ item.g_remark }}</div>
              </li>
              <!-- 配货备注 -->
              <li v-if="isColumnVisible('deliveryProductRemarks')" class="flex2 remarkCell">
                <div class="text" :title="item.p_remark"> {{ item.p_remark }}</div>
              </li>
              <!-- 业务跟单备注 -->
              <li v-if="isColumnVisible('businessFollowUpRemarks')" class="flex2 remarkCell">
                <textarea v-if="role == 1 && isAuth(180)" v-model="item.order_detail_follow_remark.y_remark"
                  class="nativeListTextarea"
                  @blur="setUpBusinessTrackingNotes(item, item.order_detail_follow_remark.y_remark)"></textarea>
                <span v-else>{{ item.order_detail_follow_remark.y_remark }}</span>
              </li>
              <!-- 业务跟单备注（内部） -->
              <li v-if="isColumnVisible('businessFollowUpInternalRemarks')" class="flex2 remarkCell">
                <textarea v-if="role == 1 && isAuth(180)" v-model="item.order_detail_follow_remark.y_remark_inside"
                  class="nativeListTextarea"
                  @blur="updateFollowYRemarkInside(item, item.order_detail_follow_remark.y_remark_inside)"></textarea>
                <span v-else>{{ item.order_detail_follow_remark.y_remark_inside }}</span>
              </li>
              <!-- 采购跟单备注-->
              <li v-if="isColumnVisible('purchaseDocumentaryRemarks')" class="flex2 remarkCell">
                <textarea v-if="role == 2 && isAuth(180)" v-model="item.order_detail_follow_remark.g_remark"
                  class="nativeListTextarea"
                  @blur="setUpProcurementTrackingNotes(item, item.order_detail_follow_remark.g_remark)"></textarea>
                <span v-else>{{ item.order_detail_follow_remark.g_remark }}</span>
              </li>

              <!-- 配送单号 -->
              <li v-if="isColumnVisible('porderNumber')" class="flex2">
                <div>
                  <p v-for="(items, indexs) in item.porder_detail" :key="indexs">
                    <router-link :to="'/porderDetail?porder_sn=' + items.porder_sn" target="_blank" class="a-link">
                      {{ items.porder_sn }}
                      {{ items.pordno.status_name }}
                    </router-link>
                  </p>
                </div>
              </li>
              <!-- 国际物流单号 -->
              <li v-if="isColumnVisible('internationalLogisticsOrderNumber')" class="flex2">
                <div>
                  <div v-for="(items, indexs) in item.porder_express_no" :key="indexs">
                    <!-- 国际物流 -->
                    <div @click="logisticsTrack(items)">
                      <el-popover placement="left" title="国际物流:" width="400" trigger="click">
                        <div v-if="GJactivities != false" style="max-height: 600px; overflow-y: auto;">
                          <el-timeline>
                            <el-timeline-item v-for="(activity, index) in GJactivities" :key="index"
                              :timestamp="activity.time" :color="activity.color" placement="top">
                              {{ activity.address }}
                            </el-timeline-item>
                          </el-timeline>
                        </div>
                        <p v-else> 暂无物流信息 </p>
                        <p slot="reference">
                          <span class="WL">
                            <a href="javascript:;" class="a-link"> {{ items }}</a>
                          </span>
                        </p>
                      </el-popover>
                    </div>
                    <!-- <router-link :to="'/porderDetail?porder_sn=' + items.porder_sn" target="_blank" class="a-link">
                    {{ items.porder_sn }}
                  </router-link> -->
                  </div>
                </div>
              </li>
              <!-- 替换链接 -->
              <li v-if="isColumnVisible('replaceTheLink')">
                <div class="template">
                  <!-- 查看已替换商品 -->
                  <p v-if="item.replace_goods_info">
                    <el-button size="mini" type="primary" @click="replaceGoodsInfo(item.replace_goods_info)">
                      替换
                    </el-button>
                  </p>
                  <!-- 编辑替换链接 -->
                  <el-button size="mini" type="primary" class="secondary" @click="editSetReplaceGoods(item)"
                    v-if="isAuth(160)">
                    {{ $t("message.redact") }}
                  </el-button>
                </div>
              </li>
              <!-- 状态 -->
              <li v-if="isColumnVisible('status')" class="fixed-right">
                <div>
                  <!-- {{ item.goods_time_node_format }} -->
                  <el-popover placement="left" width="400" height="800" trigger="click">
                    <div style="padding: 0 12px">
                      <h6 style="height: 40px;line-height: 40px;margin-bottom: 20px; ">
                        单番时间点
                      </h6>
                      <el-timeline>
                        <el-timeline-item :color="node.datetime ? '#2C96E7' : ''" size="large"
                          v-for="(node, nodeIndex) in node_list" :key="nodeIndex" v-if="node.datetime != '此节点暂无'">
                          {{ `${node.name}: ${node.datetime != null ? node.datetime : ''}` }}
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                    <el-button type="text" size="mini" slot="reference" :style="{ color: getColor(item.statusName) }"
                      @click="getSortingTimeNode(item)">
                      {{ item.statusName }}
                    </el-button>
                  </el-popover>
                  <p>
                    <!-- 检品详细 -->
                    <span @click="purchaseInspectDetail(item)" class="a-link">
                      {{ $t('message.inspectionDetail') }}
                    </span>
                  </p>
                  <div v-if="item.stock_grids && item.stock_grids.length" class="stockGridList">
                    <p v-for="(stockGrid, stockGridIndex) in item.stock_grids" :key="stockGridIndex">
                      {{ getStockGridNumber(stockGrid.grid_number) }} ({{ stockGrid.num }})
                    </p>
                  </div>
                </div>
              </li>
              <!-- 跟单备注-->
              <li v-if="isColumnVisible('documentaryRemarks')">
                <div class="documentaryRemarks">
                  <!-- 设置备注 -->
                  <el-button type="primary" size="mini" class="primary" @click="setRemark(item)">
                    {{ $t('message.Settings') }}
                  </el-button>
                  <!-- 历史 -->
                  <p style="margin-top: 10px;">
                    <el-button type="info" size="mini" @click="historyRemarkLisy(item)">
                      {{ $t('message.history') }}
                    </el-button>
                  </p>
                  <!--预抽查  -->
                  <p style="margin-top: 10px;" class="presetTaskCheck" v-if="item.preset_spot_list != false">
                    <presetTaskCheck :spotDetail="item.preset_spot_list" :order_sn="detail.order_sn" />
                  </p>
                </div>
              </li>
            </ul>
            <!-- 已付款订单展示三项要求；业务可直接编辑，其他工种只读。 -->
            <div v-if="item.materialExpanded" class="materialRequirements">
              <div class="materialRequirementsList">
                <MaterialInfo :list="item.material_list" :order-quantity="item.num" :user-id="detail.user_id"
                  :editable="isAuth(757)" :removable="isAuth(757)"
                  @update-consume="updateMaterialConsume(item, $event)" @remove="removeMaterial(item, $event)" />
              </div>
              <div class="materialRequirementsRemarks">
                <div class="requirementItem">
                  <label>{{ $t('message.productV2PurchaseRequirement') }}</label>
                  <textarea v-model="item.purchase_remark" class="nativeRequirementTextarea" rows="4"
                    :readonly="!isBusiness" @blur="savePlanRemark(item, 'purchase_remark')"></textarea>
                </div>
                <div class="requirementItem">
                  <label>{{ $t('message.productV2InspectionRequirement') }}</label>
                  <textarea v-model="item.inspect_remark" class="nativeRequirementTextarea" rows="4"
                    :readonly="!isBusiness" @blur="savePlanRemark(item, 'inspect_remark')"></textarea>
                </div>
                <div class="requirementItem">
                  <label>{{ $t('message.productV2AllocationRequirement') }}</label>
                  <textarea v-model="item.delivery_remark" class="nativeRequirementTextarea" rows="4"
                    :readonly="!isBusiness" @blur="savePlanRemark(item, 'delivery_remark')"></textarea>
                </div>
              </div>
            </div>
            <!-- 采购订单 -->
            <div class="box" v-if="item.show">
              <ul v-for="(items, indexs) in item.order_purchase" :key="items.id" class="purchase">
                <li class="fixed-left no-column purchaseSelection">
                  <div class="noSelection">
                    <el-popover placement="right" title="合计数量" width="200" trigger="focus">
                      <statistics :checkedList="selectedList" :orderPaymen="true" />
                      <el-checkbox v-model="items.checked" @change="itemChecked" slot="reference"></el-checkbox>
                    </el-popover>
                  </div>
                  <span>{{ indexs + 1 }}</span>
                </li>
                <!-- 店铺信息 -->
                <li v-if="isColumnVisible('shopInformation')" class="flex1-5">————</li>
                <!-- 照片 -->
                <li v-if="isColumnVisible('picture')" class="pic">————</li>
                <!-- 客户下单详情 -->
                <li v-if="isColumnVisible('customerOrderDetails')">————</li>
                <!-- 业务编辑属性 -->
                <li v-if="isColumnVisible('businessEditAttributes')" class="flex2">————</li>
                <!-- 报价-->
                <li v-if="isColumnVisible('businessOffer')" class="flex1-5">————</li>
                <!-- 客户付款后数量 -->
                <li v-if="isColumnVisible('customerAfterPaymentQuantity')" class="flex1-5">
                  <div class="template attribute">
                    <!-- 可入库 -->
                    <p class="row">{{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num }}</p>
                    <!-- 已到货 -->
                    <p>{{ $t("message.itHasArrived") }}:{{ items.storage_num }}</p>
                    <!-- 已出货 -->
                    <p>{{ $t("message.shipped") }}:{{ items.delivery_num }}</p>
                  </div>
                </li>
                <!-- 最终采购成本 -->
                <li class="flex1-5" v-if="userRole && isColumnVisible('finalPurchaseCost')">
                  <div class="template attribute">
                    <!-- 单价 -->
                    <p class="row">{{ $t("message.unitPrice") }}:{{ items.final_dicker_price }}</p>
                    <!-- 运费 -->
                    <p>{{ $t("message.freight") }}:{{ items.final_dicker_freight }}</p>
                  </div>
                </li>
                <!-- 客户付款后价格 -->
                <li v-if="isColumnVisible('customerAfterPaymentPrice')" class="flex1-5">
                  <div class="template attribute">
                    <!-- 单价 -->
                    <p class="row">{{ $t("message.unitPrice") }}:{{ items.price }}</p>
                    <!-- 运费 -->
                    <p>{{ $t("message.freight") }}:{{ items.freight }}</p>
                  </div>
                </li>
                <!-- 附加服务 -->
                <li v-if="isColumnVisible('additionalServices')" class="flex2">————</li>
                <!-- 标签编号 -->
                <li v-if="isColumnVisible('tagNumber')" class="tag-number">————</li>
                <!-- 交易号/物流号 -->
                <li v-if="isColumnVisible('transactionLogisticsNumber')" class="flex3">
                  <div class="template order_no attribute">
                    <p>
                      JY :
                      <router-link :to="`/inspectDetail?express_no=&purchase_no=${items.purchase_no}`" target="_blank">
                        <span class="JY">{{ items.purchase_no }}</span>
                      </router-link>
                    </p>
                    <div v-for="(express, expressIndex) in items.order_purchase_express" :key="expressIndex"
                      @click="domesticLogisticsTracking(items.purchase_no, item.from_platform, express.express_no)">
                      <el-popover placement="left" title="国内物流:" width="400" trigger="click">
                        <el-timeline v-if="activities != false">
                          <el-timeline-item v-for="(activity, index) in activities" :key="index"
                            :timestamp="activity.time" :color="activity.color" placement="top">
                            {{ activity.address }}
                          </el-timeline-item>
                        </el-timeline>
                        <p v-else> 暂无物流信息 </p>
                        <p slot="reference">
                          WL: <span class="WL"> <a href="javascript:;" class="a-link">
                              {{ express.express_no }}</a></span>
                        </p>
                      </el-popover>
                    </div>
                  </div>
                </li>
                <!-- 装箱情况 -->
                <li v-if="isColumnVisible('packingCase')" class="flex2">
                  <div class="template order_no attribute">
                    <p v-for="(box, boxIndex) in items.order_box_detail" :key="boxIndex">
                      <router-link :to="`/boxDetail?id=${box.order_box.id}&verification=${$md5(box.order_box.id + '')}`"
                        target="_blank" class="a-link">
                        {{ box.order_box.order_sn }}-{{ box.order_box.box_no }}</router-link>
                      -<span v-if="box.order_box.status == 0">(装箱中)</span>
                      <span v-else-if="box.order_box.status == 1">(已完成)</span>
                      <span v-else-if="box.order_box.status == 2">(已提出配送单)</span>
                    </p>
                  </div>
                </li>
                <!-- 客户备注 -->
                <li v-if="isColumnVisible('customerProductRemarks')" class="flex2">————</li>
                <!-- 业务回复 -->
                <!-- <li class="flex2">————</li> -->
                <!-- 业务翻译 -->
                <li v-if="isColumnVisible('businessCommodityRemarks')" class="flex2">————</li>
                <!-- 采购备注 -->
                <li v-if="isColumnVisible('purchaseCommodityRemarks')" class="flex2">————</li>
                <li v-if="isColumnVisible('deliveryProductRemarks')" class="flex2">————</li>
                <li v-if="isColumnVisible('businessFollowUpRemarks')" class="flex2">————</li>
                <li v-if="isColumnVisible('businessFollowUpInternalRemarks')" class="flex2">————</li>
                <li v-if="isColumnVisible('purchaseDocumentaryRemarks')" class="flex2">————</li>
                <!-- 配送单号 -->
                <li v-if="isColumnVisible('porderNumber')" class="flex2">
                  ————
                </li>
                <!-- 国际物流单号 -->
                <li v-if="isColumnVisible('internationalLogisticsOrderNumber')" class="flex2">
                  ————
                </li>
                <!-- 替换链接 -->
                <li v-if="isColumnVisible('replaceTheLink')">————</li>
                <!-- 状态 -->
                <li v-if="isColumnVisible('status')" class="fixed-right">
                  <span :style="{ color: getColor(items.statusName) }">
                    {{ items.statusName }}</span>
                </li>
                <!-- 跟单备注-->
                <li v-if="isColumnVisible('documentaryRemarks')">
                  ————
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 操作 -->
        <operate :detail="detail" :material-saving="materialSaving" :mark-material-disabled="markMaterialDisabled"
          :bind-material-disabled="bindMaterialDisabled" :appending-order-last-four="appendingOrderLastFour" ref="operate"
          @material-operation="handleMaterialOperation" @tag-operation="handleTagOperation" />
      </div>
      <!-- 底部 -->
      <Footer :detail="detail" :total="total" :exchange_rate="exchange_rate" :status="status" />
    </div>
    <!-- 品名编辑 -->
    <productNameEditor v-else />

    <!-- 属性编辑  -->
    <attribute v-if="attributeDialogVisible" :detail="itemDetail" />
    <!-- 检品状态详情 -->
    <inspectDetail ref="inspectDetail" :tableData="inspectDetailList" />

    <!-- 付完款分批付款展示 -->
    <afterPaymentPaymentInInstallments :order_part_pay="detail.order_part_pay" v-if="detail.order_part_pay != false"
      :rate="exchange_rate" />
    <!-- 设置备注 -->
    <setRemarks ref="setRemarks" :itemDetail="itemDetail" />
    <!-- 备注 -->
    <historyRemark ref="historyRemark" :itemDetail="itemDetail" />
    <!-- 备注提示 -->
    <promptRemarks ref="promptRemarks" />
    <!--  -->
    <!-- 同捆商品 -->
    <kitAssembly ref="kitAssembly" :order_detail="detail.order_detail" />
    <!-- 替换链接编辑 -->
    <replaceGoodsOfferEdit ref="replaceGoodsOfferEdit" />
    <!-- 替换商品信息 -->
    <replaceLink ref="replaceLink" />
    <!-- 侵权识别详情 -->
    <tortDetectDetail ref="tortDetectDetail" />
    <!-- 辅料标识选择 -->
    <MaterialSelectDialog ref="materialSelectDialog" :user-id="detail.user_id" show-status-name
      :title="$t('message.confirmMarkAsMaterial')" @confirm="confirmMarkAsMaterial" />
    <!-- 辅料使用绑定 -->
    <MaterialBindDialog ref="materialBindDialog" :user-id="detail.user_id" show-status-name
      @confirm="confirmBindMaterial" />
    <!-- 使用辅料登记弹窗，预填当前勾选商品的信息。 -->
    <MaterialForm ref="materialFormDialog" :type-list="materialTypeList" />
    <!-- 新增标签 -->
    <TagEdit ref="TagEdit" :tag-data="tagData" :save-handler="saveNewTag" goods-no-label="ASIN" delivery-display />
    <batchModifyCodeType ref="batchModifyCodeType" :save-handler="saveBatchCodeType" />
    <tagMatching ref="tagMatching" :selected-list="tagMatchTargets" :save-handler="saveTagMatching" />
    <!-- 订单详情独立维护的已打印标签补打原因弹框。 -->
    <PrintAgain ref="printAgain" :order-detail-tag-id="printReasonTagId" :save-handler="savePrintReason"
      @print="printTagCopies" @cancel="cancelPrintReason" />
    <columnSettingsDialog :visible.sync="columnSettingsVisible" :columns="availableColumnOptions"
      :value="visibleColumns" @save="saveColumnSettings" />
    <div v-show="false">
      <div v-if="printTagData" ref="tagPrint">
        <tabPrint v-for="item in tabPrintNum" :key="item" :printTagData="printTagData" :isExpress="printTagMode" />
      </div>
    </div>
  </div>
</template>

<script>
import detailHeader from "@/components/header/detailHeader";
import orderHeader from "../components/header";
import userOrderDetail from "../components/userOrderDetail";
import TagEdit from "../components/tagEdit";
import PrintAgain from "../components/printAgain";
import batchModifyCodeType from "../components/batchModifyCodeType.vue";
import tagMatching from "../components/tagMatching.vue";
import tabPrint from "@/components/Printedsheet/tag/tabPrint.vue"
import transactionNumberSplit from "../components/transactionNumberSplit";
import productNameEditor from "../components/productNameEditor";
import statistics from '../components/statistics'
import afterPaymentPaymentInInstallments from '../components/afterPaymentPaymentInInstallments'
import { getColor } from "@/utlis/utlis";
import { mapState } from "vuex";
import NP from 'number-precision' //NP.strip 处理浮点数
import attribute from "../components/attribute";
import inspectDetail from '@/components/box/inspectDetail'
import historyRemark from '@/components/documentary/historyRemark'
import setRemarks from '@/components/documentary/setRemark'
import promptRemarks from '@/components/documentary/promptRemarks'
import monitorProductSettings from "../components/monitorProductSettings";
import kitAssembly from '../components/kitAssembly'
import spotCheckDetails from '@/components/common/spotCheckDetails'
import operate from './operate.vue'
import Footer from "./foot.vue";
import replaceGoodsOfferEdit from "../components/replaceGoodsOfferEdit";
import replaceLink from '@/components/common/replaceLink'
import presetTaskCheck from '@/components/common/presetTaskCheck'
import { orderType } from '@/utlis/options'
import tortDetectDetail from './tortDetectDetail.vue'
import MaterialInfo from '@/components/common/materialInfo'
import MaterialMarkTip from '@/components/common/materialMarkTip'
import MaterialSelectDialog from '@/components/common/materialSelectDialog'
import MaterialBindDialog from '@/components/common/materialBindDialog'
import MaterialForm from '@/views/home/warehouse/material/components/materialForm'
import { getPlanRemarkSnapshot, normalizePlanRemark, shouldExpandPlanRemark } from '@/utlis/materialRemark'
import columnSettingsDialog from './columnSettingsDialog'

// NO / 选择固定显示，主订单与采购明细共用其余列配置。
const columnOptions = [
  { key: 'shopInformation', labelKey: 'message.storeInformation' },
  { key: 'picture', labelKey: 'message.pic' },
  { key: 'customerOrderDetails', labelKey: 'message.customerOrderDetails' },
  { key: 'businessEditAttributes', labelKey: 'message.businessEditAttributes' },
  { key: 'businessOffer', labelKey: 'message.businessOffer' },
  { key: 'customerAfterPaymentQuantity', labelKey: 'message.customerAfterPaymentQuantity' },
  { key: 'finalPurchaseCost', labelKey: 'message.finalPurchaseCost', purchaseOnly: true },
  { key: 'customerAfterPaymentPrice', labelKey: 'message.customerAfterPaymentPrice' },
  { key: 'additionalServices', labelKey: 'message.additionalServices' },
  { key: 'tagNumber', labelKey: 'message.tagNumber' },
  { key: 'transactionLogisticsNumber', labelKey: 'message.transactionNumberLogisticsNumber' },
  { key: 'packingCase', labelKey: 'message.packingCase' },
  { key: 'customerProductRemarks', labelKey: 'message.customerProductRemarks' },
  { key: 'businessCommodityRemarks', labelKey: 'message.businessCommodityRemarks' },
  { key: 'purchaseCommodityRemarks', labelKey: 'message.remarksForPurchasedCommodities' },
  { key: 'deliveryProductRemarks', labelKey: 'message.deliveryProductRemarks' },
  { key: 'businessFollowUpRemarks', labelKey: 'message.businessFollowUpRemarks' },
  { key: 'businessFollowUpInternalRemarks', labelKey: 'message.businessFollowUpRemarks', suffix: '（内部）' },
  { key: 'purchaseDocumentaryRemarks', labelKey: 'message.purchaseDocumentaryRemarks' },
  { key: 'porderNumber', labelKey: 'message.porderNumber' },
  { key: 'internationalLogisticsOrderNumber', labelKey: 'message.internationalLogisticsOrderNumber' },
  { key: 'replaceTheLink', labelKey: 'message.replaceTheLink' },
  { key: 'status', labelKey: 'message.status' },
  { key: 'documentaryRemarks', labelKey: 'message.documentaryRemarks' },
]
const defaultColumns = columnOptions.map(item => item.key)

export default {
  components: {
    detailHeader,
    orderHeader,
    userOrderDetail,
    TagEdit,
    PrintAgain,
    batchModifyCodeType,
    tagMatching,
    tabPrint,
    transactionNumberSplit,
    productNameEditor,
    statistics,
    attribute,
    inspectDetail,
    afterPaymentPaymentInInstallments,
    setRemarks,
    historyRemark,
    promptRemarks,
    monitorProductSettings,
    kitAssembly,
    spotCheckDetails,
    Footer,
    operate,
    replaceGoodsOfferEdit,
    replaceLink,
    presetTaskCheck,
    tortDetectDetail,
    MaterialInfo,
    MaterialMarkTip,
    MaterialSelectDialog,
    MaterialBindDialog,
    MaterialForm,
    columnSettingsDialog
  },
  metaInfo() {
    return {
      title: '订单' + this.title,
    };
  },
  data() {
    return {
      columnOptions,
      visibleColumns: [...defaultColumns],
      columnSettingsVisible: false,
      environment: location.host.indexOf('.com') !== -1 ? false : true, // 是否开发环境
      // 顶部筛选项：复制公共订单状态，避免直接修改 options.js 导出的共享对象。
      // 这里额外追加两个“直接装箱”筛选项，directPackingType 只作为本页面内部识别用：
      // unfinished = 直接装箱箱子仍在装箱中；finished = 直接装箱箱子已完成或已提出配送单。
      orderType: [
        ...orderType.map(item => ({ ...item })),
        { value: '未装箱', num: 0, directPackingType: 'unfinished' },
        { value: '装箱完成', num: 0, directPackingType: 'finished' },
      ],// 订单状态
      typeIndex: 0,
      order_detail: [],
      user_id: this.$route.query.order_sn.split('-')[1],
      title: '',
      activities: [], // 物流信息
      getColor,
      show: false,
      status: 0,
      service_rate: 0,
      exchange_rate: 0,
      //统计
      total: {
        goodsAmount: 0,
        domesticFreight: 0,
        additionalServiceCharge: 0,
        totalWeight: 0,
        totalVolume: 0,
      },
      detail: {
        order_detail: [],
        order_part_pay: [],
      },
      checked: false,
      selectedList: [], //选中的商品
      tagMatchTargets: [], //标签匹配使用的勾选商品
      selectedIDs: [], //选中的商品ID
      addGoodsDialogVisible: false,//追加
      transactionNumberSplitDialogVisible: false, //交易号拆分显示
      updatePurchaseDialogVisible: false, //交易号修改
      addExpressDialogVisible: false, //物流号添加
      deleteExpressDialogVisible: false, //物流号删除
      updateExpressDialogVisible: false, //修改物流号
      expressList: [], //物流号列表
      isOrder: true, // 订单或者品名编辑
      order_sn: this.$route.query.order_sn, //订单号
      isShowList: true,//是否显示整番
      node_list: [],//时间节点
      userRole: localStorage.getItem('japanUserRoleStatus') == 2, //是否是采购
      role: localStorage.getItem('japanUserRoleStatus'), //工种
      attributeDialogVisible: false, //属性编辑
      itemDetail: {}, //要修改项
      i: 0,//修改的索引
      attributeType: '',//编辑的类型
      inspectDetailList: [],//检品详细
      GJactivities: [],//国际物流详情
      editPic: { //修改商品图片
        order_detail_id: '',
        pic: '',
        index: 0,
      },
      personalProcedures: 0,// 个人手续费
      fileName: '',
      checkedList: [],//外层列表选择
      materialSaving: false,
      appendingOrderLastFour: false,
      materialTypeList: [],
      planRemarkSaving: false,
      markMaterialGoods: [],
      bindMaterialGoods: [],
      tagData: null,
      tagTargetList: [],
      printTagData: null,
      printTagMode: '',
      tabPrintNum: 1,
      printReasonTagId: '',
    };
  },
  computed: {

    isBusiness() {
      return Number(this.role) === 1
    },
    materialRows() {
      return Array.isArray(this.detail.order_detail) ? this.detail.order_detail : []
    },
    allMaterialsExpanded() {
      return this.materialRows.length > 0 && this.materialRows.every(item => item.materialExpanded)
    },
    availableColumnOptions() {
      return this.columnOptions.filter(item => !item.purchaseOnly || this.userRole)
    },

    // 已绑定辅料的商品不能再标识为辅料
    markMaterialDisabled() {
      return this.detail.order_detail.some(item => item.checked && this.hasBoundMaterial(item))
    },
    // 已标识为辅料的商品不能再绑定辅料使用
    bindMaterialDisabled() {
      return this.detail.order_detail.some(item => item.checked && this.isMaterial(item))
    },

    // 今日汇率
    rate() {
      return this.$store.state.rate
    },
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
      orderStatusList: (state) => state.orderStatusList,

    }),
  },
  created() {
    this.loadColumnSettings()
    this.orderDetails();

    this.$store.dispatch("getLogisticsList"); //物流方式获取
    //  personalProcedures: 0,// 个人手续费
    this.$api.orderApi.userLevelRate({ user_id: this.user_id }).then((res) => {
      this.personalProcedures = res.data[0].rate
    })
  },
  methods: {
    // 付款后订单详情使用独立的账号级表头配置。
    getColumnStorageKey() {
      let userId = 'default'
      try {
        const userInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo') || '{}')
        userId = userInfo.id || 'default'
      } catch (error) {
        userId = 'default'
      }
      return `orderPaymentDetail:columnConfig:v1:${userId}`
    },
    loadColumnSettings() {
      try {
        const savedConfig = JSON.parse(localStorage.getItem(this.getColumnStorageKey()) || '{}')
        if (savedConfig.columns) {
          this.visibleColumns = defaultColumns.filter(key => savedConfig.columns[key] !== false)
        }
      } catch (error) {
        // 本地配置损坏时使用默认展示方案
      }
    },
    isColumnVisible(key) {
      return this.visibleColumns.includes(key)
    },
    saveColumnSettings(selectedColumns) {
      const availableKeys = this.availableColumnOptions.map(item => item.key)
      this.visibleColumns = defaultColumns.filter(key => {
        return availableKeys.includes(key)
          ? selectedColumns.includes(key)
          : this.visibleColumns.includes(key)
      })
      const columns = defaultColumns.reduce((result, key) => {
        result[key] = this.visibleColumns.includes(key)
        return result
      }, {})
      localStorage.setItem(this.getColumnStorageKey(), JSON.stringify({
        version: 1,
        columns,
      }))
    },
    editTag(item, tag) {
      this.tagTargetList = [item]
      this.tagData = JSON.parse(JSON.stringify(tag))
      this.$refs.TagEdit.dialogVisible = true
    },
    // 单个和批量删除共用确认、接口和本地列表更新逻辑。
    deleteTag(item, tag) {
      this.confirmDeleteTags([{ item, tag }])
    },
    // 收集勾选商品下的全部标签，使用同一个删除接口一次提交 ID 数组。
    batchDeleteTags() {
      const targets = []
      this.detail.order_detail.forEach(item => {
        if (!item.checked || !Array.isArray(item.order_detail_tag)) return
        item.order_detail_tag.forEach(tag => targets.push({ item, tag }))
      })
      if (!targets.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      this.confirmDeleteTags(targets)
    },
    // 删除标签二次确认；接口成功后只移除当前页面对应的标签。
    confirmDeleteTags(targets) {
      this.$confirm(
        this.$t('message.areYouSureToDelete'),
        this.$t('message.hint'),
        {
          confirmButtonText: this.$t('message.ok'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning'
        }
      ).then(async () => {
        try {
          const res = await this.$api.orderApi.deleteTag({
            order_detail_tag_id: targets.map(target => target.tag.id)
          })
          targets.forEach(({ item, tag }) => {
            const tagIndex = item.order_detail_tag.indexOf(tag)
            if (tagIndex > -1) item.order_detail_tag.splice(tagIndex, 1)
          })
          this.$message.success(res && res.msg ? res.msg : this.$t('message.orderTagDeleteSuccess'))
        } catch (error) {
          this.$message.error(error && error.msg ? error.msg : this.$t('message.orderTagDeleteFailed'))
        }
      }).catch(() => {})
    },
    // 打印规则与配送单一致：mode=hide 打印纯文本标；非检品工种只打印，不登记打印状态。
    async printTag(item, tag, mode = '') {
      this.printTagData = JSON.parse(JSON.stringify(tag))
      this.printTagMode = mode
      this.tabPrintNum = 1
      if (this.role != 6) {
        this.printTagCopies(1)
        return
      }
      // 检品工种再次打印已打印标签时，必须先登记补打原因。
      if (tag.is_print) {
        this.printReasonTagId = tag.id
        this.$refs.printAgain.dialogVisible = true
        return
      }
      this.printTagCopies(1)
      try {
        await this.$api.orderApi.printTag({
          order_detail_tag_id: tag.id,
          order_detail_id: item.id,
          type: tag.type,
          no: tag.no
        })
        // 首次打印成功后只更新当前标签，不刷新订单详情。
        this.$set(tag, 'is_print', 1)
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.orderTagPrintFailed'))
      }
    },
    // 取消补打原因登记时清理当前待打印标签。
    cancelPrintReason() {
      this.printTagData = null
      this.printReasonTagId = ''
      this.tabPrintNum = 1
    },
    // 按申请数量渲染多份标签并调用浏览器打印。
    printTagCopies(num) {
      this.tabPrintNum = Number(num) || 1
      this.$nextTick(() => {
        this.$print(this.$refs.tagPrint)
        this.printTagData = null
        this.tabPrintNum = 1
        this.$forceUpdate()
      })
    },
    // 订单详情独立登记补打原因，成功后由弹框触发指定数量打印。
    async savePrintReason(data) {
      try {
        const res = await this.$api.orderApi.printReasonStore(data)
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
        return res
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.orderTagPrintReasonFailed'))
        throw error
      }
    },
    // 标签下拉菜单分发新增、批量删除、Made in China 和清空匹配数据操作。
    handleTagOperation(command) {
      if (command === 'add') this.openAddTagDialog()
      if (command === 'madeInChina') this.appendMadeInChina()
      if (command === 'orderLastFour') this.appendOrderLastFour()
      if (command === 'batchDelete') this.batchDeleteTags()
      if (command === 'clearMatchData') this.clearMatchData()
      if (command === 'batchModifyCodeType') this.openBatchModifyCodeType()
      if (command === 'copyCodeToText') this.copyCodeToText()
      if (command === 'tagMatching') this.openTagMatching()
    },
    // 打开标签匹配弹框，只允许将文件匹配到当前勾选的订单商品。
    openTagMatching() {
      const list = this.detail.order_detail.filter(item => item.checked)
      if (!list.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      this.tagMatchTargets = list
      this.$refs.tagMatching.dialogVisible = true
    },
    // 调用订单标签 textMatch 接口，成功后刷新当前订单详情。
    async saveTagMatching(data) {
      try {
        const res = await this.$api.orderApi.textMatch(data)
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
        this.tagMatchTargets = []
        await this.orderDetails()
        return res
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.tagMatchingFailed'))
        throw error
      }
    },
    // 清空当前订单的标签匹配及打印数据，成功后重新请求订单详情。
    async clearMatchData() {
      try {
        const res = await this.$api.orderApi.deleteMatchData({
          order_sn: this.order_sn
        })
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
        await this.orderDetails()
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.clearMatchDataFailed'))
      }
    },
    // 按配送单“编码-文本1”逻辑，将商品码覆盖到已勾选标签第 1 行。
    async copyCodeToText() {
      const tagIds = []
      this.detail.order_detail.forEach(item => {
        if (!item.checked || !Array.isArray(item.order_detail_tag)) return
        item.order_detail_tag.forEach(tag => tagIds.push(tag.id))
      })
      if (!tagIds.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      try {
        const res = await this.$api.orderApi.batchGoodsNoCoverTextOne({
          order_detail_tag_id_set: tagIds
        })
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
        await this.orderDetails()
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.codeCopyToTextFailed'))
      }
    },
    // 打开配送单复用的批量修改条码格式弹框，提交当前勾选标签 ID。
    openBatchModifyCodeType() {
      const tagIds = []
      this.detail.order_detail.forEach(item => {
        if (!item.checked || !Array.isArray(item.order_detail_tag)) return
        item.order_detail_tag.forEach(tag => tagIds.push(tag.id))
      })
      if (!tagIds.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      this.$refs.batchModifyCodeType.setData({
        order_sn: this.order_sn,
        order_detail_tag_id_set: tagIds
      })
    },
    // 保存订单标签条码格式修改，成功后刷新当前订单详情。
    async saveBatchCodeType(data) {
      try {
        const res = await this.$api.orderApi.batchModifyCodeType(data)
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
        await this.orderDetails()
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.batchModifyCodeTypeFailed'))
        throw error
      }
    },
    // 按配送单规则，将 Made in China 替换到已勾选标签的第 4 行。
    async appendMadeInChina() {
      const tagList = []
      this.detail.order_detail.forEach(item => {
        if (!item.checked || !Array.isArray(item.order_detail_tag)) return
        item.order_detail_tag.forEach(tag => tagList.push(tag))
      })
      if (!tagList.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      const data = {
        order_sn: this.order_sn,
        order_detail_tag_id_set: tagList.map(tag => tag.id),
        text_line_four: 'Made in China',
        is_replace: 1
      }
      try {
        const res = await this.$api.orderApi.batchAppendTagText(data)
        tagList.forEach(tag => this.$set(tag, 'text_line_four', data.text_line_four))
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.madeInChinaAddFailed'))
      }
    },
    // 与配送单后四位一致，追加到第 4 行末尾；这里取订单号主体，排除客户 ID 后缀。
    async appendOrderLastFour() {
      if (!this.isAuth(232) || this.appendingOrderLastFour) return
      const tagList = []
      this.detail.order_detail.forEach(item => {
        if (!item.checked || !Array.isArray(item.order_detail_tag)) return
        item.order_detail_tag.forEach(tag => tagList.push(tag))
      })
      if (!tagList.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      const text = this.order_sn.split('-')[0].slice(-4)
      this.appendingOrderLastFour = true
      try {
        const res = await this.$api.orderApi.batchAppendTagText({
          order_sn: this.order_sn,
          order_detail_tag_id_set: tagList.map(tag => tag.id),
          text_line_four: text
        })
        tagList.forEach(tag => this.$set(tag, 'text_line_four', (tag.text_line_four || '') + text))
        this.$message.success(res && res.msg ? res.msg : this.$t('message.saveSuccess'))
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : this.$t('message.orderLastFourAddFailed'))
      } finally {
        this.appendingOrderLastFour = false
      }
    },
    openAddTagDialog() {
      const list = this.detail.order_detail.filter(item => item.checked)
      if (!list.length) return this.$message.error(this.$t('message.selectableOperationalList'))
      const first = list[0]
      this.tagTargetList = list
      this.tagData = {
        order_detail_id: first.id,
        type: 'FBA',
        no: '',
        goods_no: '',
        // 新增标签数量默认使用当前订单商品的实时数量。
        num: first.num,
        code_type: 'CODE128',
        text_line_one: '',
        text_line_two: '',
        text_line_three: '',
        text_line_four: ''
      }
      this.$refs.TagEdit.dialogVisible = true
    },
    async saveNewTag(tagData) {
      const targetList = this.tagTargetList
      if (!targetList.length) return
      try {
        for (const item of targetList) {
          const tagPayload = {
            type: tagData.type,
            no: tagData.no,
            goods_no: tagData.goods_no,
            num: tagData.num === '' || tagData.num == null ? item.num : Number(tagData.num),
            code_type: tagData.code_type,
            text_line_one: tagData.text_line_one,
            text_line_two: tagData.text_line_two,
            text_line_three: tagData.text_line_three,
            text_line_four: tagData.text_line_four
          }
          if (tagData.id != null) {
            await this.$api.orderApi.modifyTag({
              ...tagPayload,
              order_detail_tag_id: tagData.id
            })
          } else {
            await this.$api.orderApi.updateTag({
              ...tagPayload,
              order_detail_id: item.id
            })
          }
        }
        this.$message.success(this.$t('message.saveSuccess'))
        this.tagData = null
        this.tagTargetList = []
        await this.orderDetails()
      } catch (error) {
        this.$message.error(error && error.msg ? error.msg : '标签保存失败')
        throw error
      }
    },
    // 辅料下拉菜单仅负责分发操作，具体校验和保存集中在本页面
    handleMaterialOperation(command) {
      if ((command === 'mark' || command === 'cancel') && !this.isAuth(670)) return
      if (command === 'bind' && !this.isAuth(757)) return
      if (command === 'mark') this.markAsMaterial()
      if (command === 'cancel') this.cancelMaterialMark()
      if (command === 'bind') this.bindMaterialUsage()
      if (command === 'create') this.createMaterial()
    },
    // 一个番创建一份辅料主档，复用登记辅料的字段和保存接口。
    createMaterial() {
      if (this.materialSaving || (!this.isAuth(670) && !this.isAuth(757))) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      if (list.length !== 1) {
        this.$message.error(this.$t('message.selectOneProductToCreateMaterial'))
        return
      }
      const item = list[0]
      this.$api.warehouseApi.materialTypeList().then(res => {
        this.materialTypeList = res.data || []
      })
      this.$refs.materialFormDialog.openAdd({
        user_id: this.detail.user_id,
        name_trans: item.goods_title || '',
        main_image: item.pic || ''
      }, this.detail.user ? this.detail.user.realname : '')
    },
    // 获取当前勾选的订单商品
    getCheckedMaterialGoods() {
      const list = this.detail.order_detail.filter(item => item.checked)
      if (!list.length) {
        this.$message.error(this.$t('message.selectableOperationalList'))
      }
      return list
    },
    // 订单详情中的 material 是辅料标识详情，同时兼容顶层标识字段
    isMaterial(item) {
      return Number(item.is_material) === 1 || Boolean(item.material_id) || Boolean(item.material && item.material.id)
    },
    // material_bind 是订单商品已绑定的辅料列表
    initMaterialState(item) {
      if (item.materialExpanded === undefined) {
        this.$set(item, 'materialExpanded', shouldExpandPlanRemark(item, ['purchase', 'inspect', 'delivery'], this.isBusiness))
      }
      if (item._planRemarkSnapshot === undefined) {
        this.$set(item, '_planRemarkSnapshot', getPlanRemarkSnapshot(item))
      }
      this.$set(item, 'material_list', this.getOrderMaterialList(item))
    },
    // 将接口返回的绑定数据转换为公共辅料组件需要的结构
    getOrderMaterialList(item) {
      if (!Array.isArray(item.material_bind)) return []
      return item.material_bind.map(binding => {
        const material = binding.material_detail || binding.material || {}
        // 绑定记录 ID 不是辅料主档 ID，库位查询等操作只使用主档字段。
        const materialId = binding.material_id || material.id
        return {
          ...material,
          ...binding,
          id: materialId,
          material_id: materialId,
          type: material.type || binding.type || {},
          consume: binding.consume !== undefined && binding.consume !== null ? binding.consume : 1
        }
      })
    },
    hasBoundMaterial(item) {
      if (Array.isArray(item.material_list)) return item.material_list.length > 0
      return Array.isArray(item.material_bind) && item.material_bind.length > 0
    },
    // 从当前客户的辅料列表中选择并实时保存辅料标识
    markAsMaterial() {
      if (!this.isAuth(670)) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      if (list.some(item => this.hasBoundMaterial(item))) {
        this.$message.error(this.$t('message.boundMaterialCannotMark'))
        return
      }
      this.markMaterialGoods = list
      const selectedList = list.length === 1 && list[0].material ? [list[0].material] : []
      this.$refs.materialSelectDialog.open(selectedList)
    },
    confirmMarkAsMaterial(list) {
      if (!this.isAuth(670)) return
      const material = list[0]
      const materialId = material && (material.material_id || material.id)
      if (!materialId || !this.markMaterialGoods.length) return
      if (this.markMaterialGoods.some(item => this.hasBoundMaterial(item))) {
        this.$message.error(this.$t('message.boundMaterialCannotMark'))
        return
      }
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingSignMaterial({
        user_id: this.detail.user_id,
        list: this.markMaterialGoods.map(item => ({
          order_detail_id: item.id,
          material_id: materialId
        }))
      }))
    },
    // 实时解除勾选商品的辅料标识
    cancelMaterialMark() {
      if (!this.isAuth(670)) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      this.$confirm(
        this.$t('message.confirmCancelMaterialMark'),
        this.$t('message.prompt'),
        {
          confirmButtonText: this.$t('message.ok'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.saveMaterialChange(() => this.$api.warehouseApi.sortingNotSignMaterial({
          orderDetailIds: list.map(item => item.id)
        }))
      }).catch(() => { })
    },
    // 为勾选商品绑定辅料，并支持设置单套消耗
    bindMaterialUsage() {
      if (!this.isAuth(757)) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      if (list.some(item => this.isMaterial(item))) {
        this.$message.error(this.$t('message.markedMaterialCannotBind'))
        return
      }
      list.forEach(item => this.initMaterialState(item))
      this.bindMaterialGoods = list
      const selectedList = list.length === 1 ? list[0].material_list : []
      this.$refs.materialBindDialog.open(selectedList)
    },
    confirmBindMaterial(selectedList) {
      if (!this.isAuth(757)) return
      if (!this.bindMaterialGoods.length) return
      if (this.bindMaterialGoods.some(item => this.isMaterial(item))) {
        this.$message.error(this.$t('message.markedMaterialCannotBind'))
        return
      }
      const materialList = selectedList.map(item => ({
        material_id: item.material_id || item.id,
        consume: item.consume
      }))
      const list = {}
      this.bindMaterialGoods.forEach(item => {
        list[item.id] = materialList
      })
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingBindMaterial({
        user_id: this.detail.user_id,
        list
      }))
    },
    toggleMaterial(item) {
      this.initMaterialState(item)
      item.materialExpanded = !item.materialExpanded
    },
    toggleAllMaterials() {
      const expanded = !this.allMaterialsExpanded
      this.materialRows.forEach(item => {
        this.initMaterialState(item)
        item.materialExpanded = expanded
      })
    },
    // 有勾选时批量保存当前要求；无勾选时仅保存当前商品，沿用业务编辑权限。
    async savePlanRemark(item, col) {
      if (!this.isBusiness || this.planRemarkSaving) return
      const remark = normalizePlanRemark(item[col])
      if (item._planRemarkSnapshot && item._planRemarkSnapshot[col] === remark) return

      const selectedList = this.materialRows.filter(row => row.checked || row.order_purchase.some(purchase => purchase.checked))
      const list = selectedList.length ? selectedList : [item]
      if (!list.includes(item)) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
      }
      const changedList = list.filter(row => !row._planRemarkSnapshot || row._planRemarkSnapshot[col] !== remark)
      if (!changedList.length) return
      // 使用订单明细 ID 去重，一次请求完成批量修改。
      const orderDetailIds = [...new Set(changedList.map(row => row.id))]

      this.planRemarkSaving = true
      try {
        const res = await this.$api.orderApi.updatePlanRemark({
          order_detail_id: orderDetailIds,
          col,
          remark,
        }, { isLoading: true, resolveError: true })
        if (res.code != 0 || res.success === false) {
          item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
          return
        }
        // 同一订单明细可能重复展示；成功后同步对应行，不改其他商品或要求。
        this.materialRows.filter(row => orderDetailIds.includes(row.id)).forEach(row => {
          this.$set(row, col, remark)
          if (!row._planRemarkSnapshot) this.$set(row, '_planRemarkSnapshot', getPlanRemarkSnapshot(row))
          row._planRemarkSnapshot[col] = remark
          this.$set(row, 'materialExpanded', true)
        })
        this.$message.success(res.msg)
      } catch (error) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
        // 失败提示由公共请求层处理，未保存行保持原值。
      } finally {
        this.planRemarkSaving = false
      }
    },
    // 单独修改某条辅料的单套消耗
    updateMaterialConsume(item, data) {
      if (!this.isAuth(757)) return
      const materialList = item.material_list.map((material, index) => ({
        material_id: material.material_id || material.id,
        consume: index === data.index ? data.consume : material.consume
      }))
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingBindMaterial({
        user_id: this.detail.user_id,
        list: {
          [item.id]: materialList
        }
      }))
    },
    removeMaterial(item, index) {
      if (!this.isAuth(757)) return
      const material = item.material_list[index]
      const materialId = material && (material.material_id || material.id)
      if (!materialId) return
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingUnbindMaterial({
        user_id: this.detail.user_id,
        list: {
          [item.id]: [materialId]
        }
      }))
    },
    // 保存成功后重新读取订单详情，以服务端数据为最终状态
    saveMaterialChange(save) {
      this.materialSaving = true
      return save().then(res => {
        this.$message.success(res.msg)
        return this.orderDetails()
      }).then(() => {
        this.markMaterialGoods = []
        this.bindMaterialGoods = []
        this.checkedList = []
        this.checked = false
      }).finally(() => {
        this.materialSaving = false
      })
    },
    getTitle(status) {
      this.title = this.orderStatusList.find(item => item.key == status).value

    },
    // 物流方式转换
    logistics(id) {
      let name;
      this.logisticsList.forEach((item) => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },

    //详情
    orderDetails() {
      let datas = {
        order_sn: this.order_sn,
        is_japanfirm: this.$route.query.is_japanfirm,
      }
      return this.$api.orderApi
        .orderDetails(datas)
        .then((res) => {
          // console.log(res);

          this.service_rate = res.data.service_rate - 0;
          this.exchange_rate = res.data.exchange_rate - 0;
          this.status = res.data.status;
          this.dataProcessing(res.data);
          this.show = true;
          this.checked = false;
          this.$forceUpdate();
          this.getTitle(res.data.status)
          // 查看跟单备注
          this.$refs.promptRemarks.lookPromptRemarks(res.data.order_detail)
          // 抽查任务查询
          this.getSpotOrderDetail()
        });
    },
    // 数据处理
    dataProcessing(detail) {
      detail.order_detail.forEach((item) => {
        let itemData = detail.order_detail.find(items => items.set_detail_id == item.id) //查询是否是组套主商品
        if (itemData) {
          item.isZhu = true
          item.group = itemData.group
        }
        item.problem_goods = []
        // 配送单数组去重
        var hash = {};
        item.porder_detail = item.porder_detail.reduce(function (items, next) {
          hash[next.porder_sn]
            ? ""
            : (hash[next.porder_sn] = true && items.push(next));
          return items;
        }, []);
        item.checked = false;
        this.initMaterialState(item)

        item.order_purchase.forEach((items) => {
          item.problem_goods = [...item.problem_goods, ...items.problem_goods]
          items.checked = false;
        });
        item.show = false;
        if (item.detail_y == null) {
          item.detail_y = item.detail;
        }
        item.userTotal = this.ceil(item.num * item.price)//客户小计
        if (!item.volume) {
          item.volume = "0x0x0";
        }
        item.volumes = item.volume.split("x");
        item.length = item.volumes[0];
        item.width = item.volumes[1];
        item.height = item.volumes[2];
        item.offer_num = item.offer_num_bak; //报价数量
        item.offer_freight = item.offer_freight_bak; //报价运费
        item.offer_price = item.offer_price_bak; // 报价单价
        item.offer_total =
          item.offer_num_bak * item.offer_price_bak + (item.offer_freight_bak - 0);
        item.client_modify_field = item.client_modify_field == null ? [] : item.client_modify_field
        // 业务跟单备注
        item.order_detail_follow_remark = item.order_detail_follow_remark == null ? {} : item.order_detail_follow_remark
        item._remarkSnapshot = {
          y_remark: this.normalizeRemark(item.y_remark),
          follow_y_remark: this.normalizeRemark(item.order_detail_follow_remark.y_remark),
          follow_y_remark_inside: this.normalizeRemark(item.order_detail_follow_remark.y_remark_inside),
          follow_g_remark: this.normalizeRemark(item.order_detail_follow_remark.g_remark),
        }
      });
      // 工厂直发用
      detail.order_augment = detail.order_augment == null ? {} : detail.order_augment
      detail.order_augment.is_y_performance = detail.order_augment.is_y_performance ? true : false //是否计算业务绩效
      detail.order_augment.is_g_performance = detail.order_augment.is_g_performance ? true : false //是否计算采购绩效
      detail.order_augment.is_p_performance = detail.order_augment.is_p_performance ? true : false //是否计算配货绩效
      detail.goods_fee_rule = detail.goods_fee_rule ? true : false //0-收商品金额,1-不收商品金额
      detail.service_fee_rule = detail.service_fee_rule ? true : false //0-按默认规则收取,1-按客户等级收取
      detail.order_bulk = detail.order_bulk == null ? { air_price: '', sea_price: '' } : detail.order_bulk
      this.detail = detail;
      this.$forceUpdate();
      // 存入vuex
      // this.$store.commit('getDetail', detail)
      this.computationalSost();
      // 重置数量
      this.orderType.forEach(item => {
        item.num = 0
      })
      // 填充顶部筛选数量。
      // 普通订单状态按番统计；直接装箱筛选也按番统计：
      // 一个番下面即使有多个交易号或多个箱子，只要命中对应装箱状态，就只累计 1 个番数。
      this.detail.order_detail.forEach(item => {
        this.orderType.forEach(items => {
          if (items.value == '全部') {
            items.num++
          } else if (items.directPackingType) {
            // 直接装箱状态来自番下面的 order_purchase.order_box_detail。
            // matchDirectPackingFilter 返回 true 时代表当前番命中该筛选条件。
            items.num += this.matchDirectPackingFilter(item, items.directPackingType) ? 1 : 0
          } else if (items.value == item.statusName) {
            items.num++
          }
        })
      })
      this.filterList('全部', 0)
    },
    //显示番
    getSorting(set_detail_id) {
      let itemData = this.detail.order_detail.find(item => item.id == set_detail_id)
      return itemData.sorting
    },
    // 库位仅显示“】-”后的实际编号。
    getStockGridNumber(gridNumber) {
      if (!gridNumber) return ''
      const separatorIndex = gridNumber.indexOf('】-')
      return separatorIndex === -1 ? gridNumber : gridNumber.slice(separatorIndex + 2)
    },
    // 筛选状态
    filterList(type, index) {
      const currentType = this.orderType[index] || {}
      if (currentType.directPackingType) {
        // 点击“未装箱 / 装箱完成”时，需要看到每个番下面的交易号和箱子明细，
        // 因此强制展开整番明细，并同步 isShowList=true。
        this.roundDisplay(true)
      }
      this.order_detail = []
      this.detail.order_detail.forEach(item => {
        if (type == '全部') {
          this.order_detail.push(item)
        } else if (currentType.directPackingType && this.matchDirectPackingFilter(item, currentType.directPackingType)) {
          // 直接装箱筛选不看订单 statusName，而是看箱子状态是否命中当前筛选项。
          this.order_detail.push(item)
        } else if (item.statusName == type) {
          this.order_detail.push(item)
        }
      })
      this.typeIndex = index
    },
    // 判断一个番是否命中直接装箱筛选。
    // 后端箱子状态约定：0=装箱中，1=装箱完成，2=已提出配送单。
    // 本页面的“未装箱”对应 status=0；“装箱完成”包含 status=1 和 status=2。
    matchDirectPackingFilter(item, type) {
      const boxDetails = this.getDirectPackingBoxDetails(item)
      if (type == 'unfinished') {
        return boxDetails.some(box => this.getDirectPackingBoxStatus(box) === 0)
      }
      if (type == 'finished') {
        return boxDetails.some(box => [1, 2].includes(this.getDirectPackingBoxStatus(box)))
      }
      return false
    },
    // 汇总当前番下所有交易号关联的直接装箱明细。
    // 页面数据结构是：番(order_detail) -> 交易号(order_purchase) -> 箱子明细(order_box_detail)，
    // 所以筛选统计前需要先把每个交易号的 order_box_detail 拉平成同一个数组。
    getDirectPackingBoxDetails(item) {
      let boxDetails = []
      if (!item || !Array.isArray(item.order_purchase)) return boxDetails
      item.order_purchase.forEach(purchase => {
        if (Array.isArray(purchase.order_box_detail)) {
          boxDetails = [...boxDetails, ...purchase.order_box_detail]
        }
      })
      return boxDetails
    },
    // 取箱子状态，并统一转成数字，兼容接口把 status 放在 order_box.status
    // 或直接放在 order_box_detail.status 上的两种返回结构。
    getDirectPackingBoxStatus(boxDetail) {
      const status = boxDetail && boxDetail.order_box ? boxDetail.order_box.status : boxDetail.status
      return Number(status)
    },
    // 计算费用
    computationalSost() {
      this.total = {
        goodsAmount: 0,
        domesticFreight: 0,
        additionalServiceCharge: 0,
        totalWeight: 0,
        totalVolume: 0,
        totalNum: 0
      };
      this.detail.order_detail.forEach((item) => {
        this.total.totalNum += item.possible_num_total - 0
        this.total.goodsAmount += item.possible_num_total * item.confirm_price;
        if (item.possible_num_total > 0) {
          this.total.domesticFreight += item.confirm_freight - 0;
        }
        if (item.option != null) {
          item.option.forEach((opti) => {
            // 按照% 收手续费
            if (opti.price_type == 1) {
              this.total.additionalServiceCharge +=
                NP.strip(item.confirm_price * opti.num * (opti.price / 100));
            } else {
              this.total.additionalServiceCharge += opti.num * opti.price;
              // console.log(opti.num, opti.price);
            }
            this.total.additionalServiceCharge = NP.strip(this.total.additionalServiceCharge)
          });
        }
        this.total.totalWeight += item.weight - 0;
        this.total.totalVolume += item.length * item.width * item.height;
      });
    },
    //订单选择
    orderChecked() {
      this.detail.order_detail.forEach((item) => {
        item.order_purchase.forEach((items) => {
          items.checked = item.checked;
        });
      });
      this.isAllChecked();
    },

    // 是否全选
    isAllChecked() {
      let flag = this.detail.order_detail.every((item) => item.checked);
      this.checked = flag;
      this.selected()
      this.$forceUpdate();
    },
    //单项选择
    itemChecked() {
      this.detail.order_detail.forEach((item) => {
        let flag = item.order_purchase.every((items) => items.checked);
        item.checked = flag;
      });
      this.isAllChecked();
    },
    // 选中的商品id
    selected() {
      this.selectedList = [];
      this.selectedIDs = [];
      this.detail.order_detail.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            items.detail = item.detail;
            items.detail_y = item.detail_y;
            items.pic = item.pic;
            items.sorting = item.sorting;
            items.newNum = 1;
            this.selectedList.push(items);
            this.selectedIDs.push(items.id);
          }
        });
      });
      this.$forceUpdate();
    },
    //整番显示
    roundDisplay(flag) {
      this.isShowList = flag
      this.detail.order_detail.forEach((item) => {
        item.show = flag
      })
      this.$forceUpdate()
    },
    //修改备注
    // 统一备注内容格式，避免 null 和空字符串比较时误判
    normalizeRemark(value) {
      return value == null ? '' : String(value)
    },
    // 判断当前备注内容是否和初始快照不同
    isRemarkChanged(item, key, value) {
      if (!item._remarkSnapshot) {
        this.$set(item, '_remarkSnapshot', {})
      }
      return this.normalizeRemark(item._remarkSnapshot[key]) !== this.normalizeRemark(value)
    },
    // 保存成功后更新备注快照，避免重复失焦再次请求
    updateRemarkSnapshot(item, key, value) {
      if (!item._remarkSnapshot) {
        this.$set(item, '_remarkSnapshot', {})
      }
      this.$set(item._remarkSnapshot, key, this.normalizeRemark(value))
    },
    updateGoodsRemark(item, remark, type) {
      if (!this.isRemarkChanged(item, 'y_remark', remark)) return
      let datas = {
        order_sn: this.order_sn,
        remark,
        order_detail_id_set: [],
        remark_type: type
      }
      if (item.checked) {
        this.detail.order_detail.forEach(items => {
          if (items.checked) {
            datas.order_detail_id_set.push(items.id)
          }
        })
      } else {
        datas.order_detail_id_set = [item.id]
      }
      this.$api.orderApi.updateGoodsRemark(datas).then(res => {
        this.updateRemarkSnapshot(item, 'y_remark', remark)
        this.$message.success(res.msg)
        this.orderDetails()
      })
    },
    //获取国内物流轨迹
    domesticLogisticsTracking(purchase_no, from_platform, express_no) {
      let datas = {
        purchase_no,
        from_platform,
        express_no
      }
      this.activities = []
      this.$api.domesticLogisticsTracking(datas).then(res => {
        if (res.data.all_adress != false) {
          res.data.all_adress[0].color = '#B4272D'
        }
        this.activities = res.data.all_adress
      })
    },
    //时间点
    getSortingTimeNode(item) {
      let datas = {
        order_detail_id_set: [item.id]
      }
      this.node_list = []
      this.$api.orderApi.getSortingTimeNode(datas).then(res => {
        this.node_list = res.data[0].node_list
        console.log(res);
      })
    },
    //业务修改属性
    attributeEdit(item, i, type) {
      this.attributeType = type
      this.i = i;
      this.itemDetail = item;
      this.attributeDialogVisible = true;
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic, arr, spec_id) {
      if (this.attributeType == 'Y') {
        let datas = {
          order_detail_id: this.itemDetail.id,
          sku_id_y: spec_id,
          spec_id_y: spec_id,
          detail_y: data
        }
        this.$api.orderApi.updateSortingDetail(datas).then(res => {
          this.$message.success(res.msg)
          this.detail.order_detail[this.i].detail_y = data;
          this.detail.order_detail[this.i].spec_id_y = spec_id
          this.detail.order_detail[this.i].sku_id_y = spec_id
          if (pic) {
            this.detail.order_detail[this.i].pic = pic;
          }
          this.attributeDialogVisible = false;
        })
      } else {
        let datas = {
          order_detail_id: this.itemDetail.id,
          sku_id: spec_id,
          spec_id: spec_id,
          detail: data
        }
        this.$api.orderApi.updateOrderDetail(datas).then(res => {
          this.$message.success(res.msg)
          this.detail.order_detail[this.i].detail_ = data;
          this.detail.order_detail[this.i].spec_id = spec_id
          this.detail.order_detail[this.i].sku_id = spec_id
          this.orderDetails()
          this.$forceUpdate()
          // if (pic) {
          //   this.detail.order_detail[this.i].pic = pic;
          // }
          this.attributeDialogVisible = false;
        })
      }
    },
    //检品详情
    purchaseInspectDetail(item) {
      let datas = {
        order_purchase_ids: []
      }
      item.order_purchase.forEach(items => {
        datas.order_purchase_ids.push(items.id)
      })
      this.$api.followApi.purchaseInspectDetail(datas).then(res => {
        this.inspectDetailList = res.data[0].inspect_detail
        this.$refs.inspectDetail.dialogVisible = true
      })
    },
    // 双路检测中只要有一路明确为高风险，就显示侵权风险入口。
    isShowTortRisk(tortDetect) {
      return !!tortDetect && (
        tortDetect.vision_risk_level == 'high' ||
        tortDetect.fingerprint_risk_level == 'high'
      )
    },
    // 取双路中更高的风险等级：high > medium
    getTortRiskLevel(tortDetect) {
      if (!tortDetect) return ''
      const levels = [tortDetect.vision_risk_level, tortDetect.fingerprint_risk_level]
      if (levels.indexOf('high') != -1) return 'high'
      if (levels.indexOf('medium') != -1) return 'medium'
      return ''
    },
    // 高风险红色，中风险橙色
    getTortRiskType(tortDetect) {
      return this.getTortRiskLevel(tortDetect) == 'high' ? 'danger' : 'warning'
    },
    // 打开当前商品的侵权识别详情
    openTortDetect(item) {
      this.$refs.tortDetectDetail.openDialog(item)
    },
    // 设置备注
    setRemark(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.setRemarks.dialogVisible = true
    },
    // 历史备注
    historyRemarkLisy(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.historyRemark.dialogVisible = true
    },
    //订单-修改管理番号
    batchUpdateOrderDetailForSn(item) {
      let datas = {
        order_detail_id_set: [item.id],
        for_sn: item.for_sn
      }
      this.$api.orderApi.batchUpdateOrderDetailForSn(datas)
    },
    //订单-尝试补全订单信息
    reCompletion() {
      this.$api.orderApi.reCompletion({ order_sn: this.order_sn }).then(res => {
        this.$message.success(res.msg)
        this.orderDetails();
      })
    },
    //修改计算绩效规则
    updateOrderPerformance() {
      let datas = {
        order_sn: this.order_sn,
        is_y_performance: this.detail.order_augment.is_y_performance ? 1 : 0,
        is_g_performance: this.detail.order_augment.is_g_performance ? 1 : 0,
        is_p_performance: this.detail.order_augment.is_p_performance ? 1 : 0,
      }
      this.$api.orderApi.updateOrderPerformance(datas)
    },
    // 跳转物流
    logisticsTrack(express_no) {
      let datas = {
        express_no
      }
      this.$api.logisticsTrack(datas).then(res => {
        if (res.data.address_data != false) {
          res.data.address_data[0].color = '#B4272D'
        }
        this.GJactivities = res.data.address_data
      })
    },
    // 上传成功
    updateOrderImage(res) {
      this.order_detail[this.editPic.index].pic = res.data;
      this.editPic.pic = res.data;
      this.$api.orderApi.updateOrderImage(this.editPic).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 修改图片参数
    setPic(index, id) {
      this.editPic = { //修改商品图片
        order_detail_id: id,
        pic: '',
        index
      }
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    // 删除
    deleteOrderFile(id, i) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.deleteOrderFile({ id }).then((res) => {
            this.$message.success(res.msg);
            this.detail.order_file.splice(i, 1)
          });
        })
        .catch(() => { });
    },
    //抽查任务查询
    getSpotOrderDetail() {
      let datas = {
        order_sn: this.order_sn,
      }
      this.$api.spotCheckApi.getSpotOrderDetail(datas).then(res => {
        let spotList = res.data
        for (let key in spotList) {
          let itemData = this.detail.order_detail.find(item => item.id == key)
          if (spotList[key] != false) {
            itemData.spotDetail = spotList[key]
          }
        }
        this.$forceUpdate()
        // console.log(this.detail.order_detail);

      })
    },
    // 编辑替换链接
    editSetReplaceGoods(item) {
      this.$refs.replaceGoodsOfferEdit.form = {
        link: '',
        order_detail_id: item.id,
        from_platform: '',
        goods_id: '',
        pic: '',
        shop_id: '',
        shop_name: '',
        detail: [],
        sku_id: '',
        spec_id: '',
        detail_y: [],
        sku_id_y: '',
        spec_id_y: '',
      }
      this.$refs.replaceGoodsOfferEdit.dialogVisible = true
    },
    // 替换商品信息
    replaceGoodsInfo(replace_goods_info) {
      this.$refs.replaceLink.replace_goods_info = replace_goods_info
      this.$refs.replaceLink.dialogVisible = true
    },
    // 设置业务跟单备注
    setUpBusinessTrackingNotes(item, remark) {
      if (!this.isRemarkChanged(item, 'follow_y_remark', remark)) return
      this.$api.orderApi
        .updateFollowYRemark({ order_detail_id_set: [item.id], y_remark: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          this.updateRemarkSnapshot(item, 'follow_y_remark', remark)
          //接下来的操作
        });
    },
    // 设置业务跟单备注（内部）
    updateFollowYRemarkInside(item, remark) {
      if (!this.isRemarkChanged(item, 'follow_y_remark_inside', remark)) return
      this.$api.orderApi
        .updateFollowYRemarkInside({ order_detail_id_set: [item.id], y_remark_inside: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          this.updateRemarkSnapshot(item, 'follow_y_remark_inside', remark)
          //接下来的操作
        });
    },
    // 设置采购跟单备注
    setUpProcurementTrackingNotes(item, remark) {
      if (!this.isRemarkChanged(item, 'follow_g_remark', remark)) return
      this.$api.orderApi
        .updateFollowGRemark({ order_detail_id_set: [item.id], g_remark: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          this.updateRemarkSnapshot(item, 'follow_g_remark', remark)
          //接下来的操作
        });
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/.el-timeline-item {
  padding-bottom: 5px;
}

/deep/.el-textarea__inner {
  height: 132px;
}

.list {
  /deep/ .el-input__inner {
    padding: 0;
  }
}



/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }

  .el-checkbox__inner,
  .el-checkbox__label {
    color: #606266 !important;
  }
}

ul {
  /deep/.el-textarea__inner {
    max-height: 150px !important;
    padding: 0;
  }

  /deep/.is-disabled {
    .el-textarea__inner {
      background-color: #fef0f0 !important;
      color: #606266;
    }
  }
}

.tableList {
  ol {
    display: flex;

    li {
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flex2 {
    .text {
      word-break: break-all;
      max-height: 200px;
      overflow-y: auto;
    }

  }

  .tag-number {
    .tag-content {
      .tag-card {
        width: 100%;
        // 参考配送单的单标签卡片：白色背景并保留少量内容间距。
        padding: 6px;
        margin-bottom: 8px;
        box-sizing: border-box;
        border-radius: 4px;
        background-color: #fff;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .tag-record {
        width: 100%;
        padding: 0;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        box-sizing: border-box;

        .tag-field {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #ebeef5;

          .tag-label {
            flex: 0 0 72px;
            padding: 4px 6px;
            border-right: 1px solid #ebeef5;
            box-sizing: border-box;
          }

          .tag-value {
            flex: 1;
            min-width: 0;
            padding: 4px 6px;
            word-break: break-all;
          }

          // 纯文本标入口与配送单一致，固定在标签数量行右侧。
          .tag-count-value {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 4px;
            word-break: normal;

            .el-button {
              flex: none;
              margin-left: 0;
            }
          }
        }

        .tag-field:last-child {
          border-bottom: none;
        }
      }

      .tag-actions {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 4px;
        margin: 0;
        padding: 0 0 8px;
        border-bottom: none;


        .tag-print {
          margin-left: auto !important;
        }
        .el-button {
          margin-left: 0;
        }
      }
    }

  }

  .goodsId {
    color: #409eff;
    cursor: pointer;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    position: relative;

    .pic {
      position: relative;
      cursor: pointer;

      .tort-detect-tag {
        margin-bottom: 5px;
        cursor: pointer;
      }

    }

    .editpic {
      text-align: right;
      z-index: 99;

      i {
        font-size: 18px;
        color: #B4272D;
        cursor: pointer;
      }
    }

    .template {
      text-align: center;
      width: 100%;
      overflow: hidden;

      p {
        margin-bottom: 5px;

        word-break: break-all;
      }
    }

    .attribute {
      text-align: left;
      width: 100%;
      position: relative;

      .el-icon-edit-outline {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        color: #c60524;
        font-size: 18px;
      }

      .row {
        width: 100%;
        margin-bottom: 5px;
      }
    }

    .services {
      text-align: left;
      line-height: 16px;
    }

    .text {
      padding: 5px;
    }

    .order_no {
      .JY {
        color: #fa5058;
      }

      .WL {
        color: #2c96e7;
      }
    }

    .NO {
      .materialToggle {
        min-width: 56px;
        height: 24px;
        padding: 0 6px;
        border: 0;
        border-radius: 4px;
        background-color: #f5f7fa;
        color: #606266;

        &:hover,
        &:focus {
          background-color: #ecf5ff;
          color: #409eff;
        }

        i {
          margin-left: 2px;
          font-size: 12px;
        }
      }

      .claim {
        i {
          color: #B4272D;
          font-size: 20px;
        }
      }

      .isZhu {
        color: #B4272D;
        font-weight: 600;
        cursor: pointer;
      }

      .isTong {
        color: #85ce61;
      }

      .wen {
        width: 24px;
        height: 24px;
        background: #c60524;
        border-radius: 12px;
        text-align: center;
        line-height: 24px;
        color: #fff;
      }

      b {
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;

        i {
          font-size: 18px;
          transform: translate(0, 1px);
        }
      }
    }

    .documentaryRemarks {
      width: 100%;
      text-align: center;

      .el-button {
        padding: 8px 0;
        width: 100%;
        max-width: 100px;
      }
    }
  }

  // 左右区域等宽；左侧辅料横向滚动时不改变右侧要求的宽度。
  .materialRequirements {
    display: flex;
    gap: 24px;
    min-width: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #edeff4;
    background-color: #fff;
    box-sizing: border-box;
  }

  .materialRequirementsList,
  .materialRequirementsRemarks {
    flex: 1 1 0;
    min-width: 0;
  }

  .materialRequirementsList {
    /deep/ .material-info-panel {
      padding: 0;
      border: 0;
    }

    /deep/ .material-list {
      display: flex;
      overflow-x: auto;
      padding: 10px 10px 8px 0;
    }

    /deep/ .material-card {
      flex: 0 0 288px;
    }

    /deep/ .empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 136px;
      padding: 0;
    }
  }

  .materialRequirementsRemarks {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }

  .requirementItem {
    display: flex;
    flex-direction: column;
    min-width: 0;

    label {
      display: block;
      margin-bottom: 10px;
      color: #333;
      font-size: 14px;
      font-weight: bold;
    }

    /deep/ .el-textarea {
      display: flex;
      flex: 1;
    }

    /deep/ .el-textarea__inner {
      flex: 1;
      min-height: 96px;
      height: auto;
    }
  }

  .purchase {
    background: #f0f0f0;
    text-align: center;

  }

  .fixed-right {
    position: sticky;
    right: 0;
    top: 0;
    background-color: #edeff4;

    .stockGridList {
      margin-top: 10px;
      color: #409eff;

      p {
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

}

// 已付款订单列表只优化视觉层级和可读性，不改变列、操作及业务判断。
.detail {
  min-width: 1910px;
  min-height: 100vh;
  background-color: #f5f7fa;

  .top-btn {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin: 16px 20px 0;
    padding: 14px 16px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;

    .el-button,
    .materialBatchToggle {
      margin: 0;
    }

    .columnSettingsButton {
      margin-left: auto;
    }

    .item {
      padding: 8px 16px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      background-color: #fff;
      color: #333;
      cursor: pointer;
      transition: color 0.2s, border-color 0.2s, background-color 0.2s;

      &:hover {
        color: #b4272d;
        border-color: #d99a9d;
      }
    }

    .select,
    .select:hover {
      color: #fff;
      border-color: #b4272d;
      background-color: #b4272d;
    }
  }

  .orderDetail {
    overflow: visible;
    margin: 16px 20px 24px;
    padding: 0;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(31, 45, 61, 0.06);
  }
}

// 商品列表使用原生表单控件，减少大量 Element Input 实例带来的渲染开销。
.nativeListInput,
.nativeListTextarea,
.nativeRequirementTextarea {
  display: block;
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  outline: none;
  background-color: #fff;
  color: #606266;
  font-family: inherit;
  font-size: inherit;
  box-sizing: border-box;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:focus {
    border-color: #409eff;
  }

  &::placeholder {
    color: #c0c4cc;
  }
}

.nativeListInput {
  height: 28px;
  padding: 0;
  line-height: 28px;
}

.nativeListTextarea,
.nativeRequirementTextarea {
  resize: none;
}

.nativeRequirementTextarea {
  flex: 1;
  min-height: 96px;
  height: auto;
  padding: 5px 15px;
  line-height: 1.5;
}

.tableList {
  // 商品列表按可视高度独立滚动，表头只在列表滚动区域内吸顶。
  max-height: calc(100vh - 220px);
  overflow: auto;
  font-size: 13px;
  line-height: 1.5;
  background-color: #fff;

  ol,
  ul {
    width: max-content;
    min-width: 100% !important;
  }

  ol {
    position: sticky;
    top: 0;
    left: 0;
    // 高于列表内图片编辑、标记等浮层，避免滚动内容穿透表头。
    z-index: 200;
    height: 52px;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0;
    background-color: #eef1f6;
    box-shadow: 0 2px 6px rgba(31, 45, 61, 0.08);

    li {
      height: 52px;
      padding: 8px 10px;
      color: #303133;
      font-weight: 600;
      line-height: 18px;
    }

    // 后半段表头按备注、单号等业务分组区分颜色，横向浏览时更容易定位。
    .customerRemarkHeader {
      color: #c45656;
      background-color: #fef0f0;
    }

    .remarkGroupHeader {
      color: #b88230;
      background-color: #fdf6ec;
      max-height: 100px;
      overflow: hidden;
    }

    .orderReferenceHeader {
      color: #337ecc;
      background-color: #ecf5ff;
    }
  }

  li {
    flex: 0 0 96px;
    width: 96px;
    margin-right: 0;
    padding: 12px 10px;
    border-right: 1px solid #ebeef5;
    box-sizing: border-box;

    &:last-child {
      border-right: 0;
    }
  }

  .flex1-5,
  .shop {
    flex-basis: 120px;
    width: 120px;
  }

  .shop {
    flex-grow: 0;
    flex-shrink: 0;
  }

  .flex2 {
    flex-basis: 180px;
    width: 180px;
  }

  .flex3 {
    flex-basis: 240px;
    width: 240px;
  }

  .tag-number {
    flex-basis: 320px;
    width: 320px;
  }

  .no-column {
    flex-basis: 128px;
    width: 128px;
  }

  ul {
    align-items: stretch;
    padding: 0;
    background-color: #fff;

    > li {
      min-height: 156px;
      align-items: flex-start;
      padding-top: 16px;
      padding-bottom: 16px;
    }

    // 附加服务至少展示 200px，服务项目较多时继续按内容自然撑高整行。
    .additionalServicesCell {
      min-height: 200px;
      align-self: stretch;

      .services,
      .serviceOptionList {
        max-height: none;
        overflow: visible;
      }
    }

    &:hover {
      background-color: #f7fbff;
    }

    // 客户商品备注整列使用提示色，保持禁用输入框的内容仍然清晰可读。
    .customerRemarkCell {
      background-color: #fff7f7;

      .nativeListTextarea {
        color: #606266;
        background-color: #fef0f0 !important;
        border-color: #fbc4c4;
        opacity: 1;
        -webkit-text-fill-color: #606266;
      }
    }

    // 备注框最小 200px，最大只跟随父级单元格高度；内容过多时在框内滚动。
    .remarkCell {
      align-self: stretch;
      overflow: hidden;

      /deep/ .el-textarea {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        width: 100%;
        height: 100%;
        min-height: 200px;
        max-height: 100%;
        overflow: hidden;
      }

      /deep/ .el-textarea__inner {
        flex: 1 1 auto;
        min-height: 200px !important;
        max-height: 100% !important;
        height: 100% !important;
        overflow-y: auto;
      }

      .nativeListTextarea {
        flex: 1 1 auto;
        align-self: stretch;
        min-height: 200px;
        max-height: 100%;
        height: 100%;
        padding: 8px 10px;
        overflow-y: auto;
        line-height: 1.5;
      }

      span,
      .text {
        display: block;
        width: 100%;
        height: 100%;
        max-height: 100%;
        overflow-y: auto;
        white-space: pre-wrap;
        word-break: break-word;
      }
    }

    .template,
    .attribute,
    .text {
      line-height: 1.6;
    }

    .attribute {
      padding: 0 4px;
      box-sizing: border-box;
    }

    .NO {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 12px;
      padding-right: 12px;
      padding-left: 12px;

      .noTopRow {
        display: flex;
        flex: none;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        width: 100%;
        min-height: 30px;

        b {
          display: inline-flex;
          align-items: center;
          gap: 8px;

          i {
            color: #b4272d;
          }
        }
      }

      .noSelection {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: none;
        width: 28px;
      }

      .noStatusArea {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        width: 100%;
        min-height: 0;
      }

      .noBadgeRow {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;

        .materialMarkTip,
        .wen,
        .inSale {
          position: static;
        }

        .wen {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: none;
        }
      }

      .noStatusArea .claim,
      .noStatusArea .isZhu {
        position: static;
      }

      .noStatusArea .isZhu {
        width: auto;
        max-width: 100%;
        min-height: 22px;
        padding: 2px 6px;
        border: 1px solid #f56c6c;
        border-radius: 3px;
        background-color: #fef0f0;
        box-sizing: border-box;
        line-height: 16px;
      }

      .noStatusArea .isTong {
        border-color: #67c23a;
        background-color: #f0f9eb;
      }

      .contraband {
        position: static;

        img {
          display: block;
        }
      }

      .materialToggle {
        position: static;
        flex: none;
        align-self: flex-start;
        margin-top: auto;
      }
    }

    .purchaseSelection {
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 12px;
      padding-right: 12px;
      padding-left: 12px;
      text-align: left;

      .noSelection {
        display: flex;
        flex: none;
        align-items: center;
        justify-content: center;
        width: 28px;
      }
    }

    // 展开的采购副列表使用与主列表一致的行边框和单元格分隔线。
    &.purchase {
      border-bottom: 1px solid #dcdfe6;
      box-shadow: inset 1px 0 #dcdfe6, inset -1px 0 #dcdfe6;

      &:first-child {
        border-top: 1px solid #dcdfe6;
      }

      > li {
        border-right-color: #dcdfe6;
      }

    }

    .tag-content {
      padding: 0;

      .tag-card {
        border: 1px solid #e4e7ed;
        box-shadow: 0 1px 4px rgba(31, 45, 61, 0.06);
      }

      .tag-record .tag-field {
        min-height: 30px;
      }
    }

    /deep/ .el-textarea__inner {
      padding: 8px 10px;
      line-height: 1.5;
    }
  }

  .list:nth-child(even) > ul:first-child {
    background-color: #fafbfd;
  }
}

.editItem {
  background-color: #FFF189 !important;
}

.addItem {
  background-color: #85ce61 !important;
}
</style>
